import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row justify-between" }
const _hoisted_2 = { class: "text-body1" }
const _hoisted_3 = { class: "row items-center q-pb-sm" }
const _hoisted_4 = { class: "row items-center q-pb-sm" }
const _hoisted_5 = { class: "row items-center q-pb-sm" }
const _hoisted_6 = { class: "row items-center q-pb-sm" }
const _hoisted_7 = { class: "row items-center q-pb-sm" }

import router from "src/router"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxFilterSystemLink from "src/components/filter/SfxFilterSystemLink.vue"
import SfxPriorityFilter from "../priority-filter/SfxPriorityFilter.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import SfxSeparator from "src/components/special/SfxSeparator.vue"
import SfxToggleSettings from "src/components/toggle/SfxToggleSettings.vue"
import { ISSUE_FILTER_DIALOG_DEFAULT, ISSUE_FILTER_STATE } from "src/util/constants/filters"
import {
  ENTITY_TYPE,
  INCLUDE_REJECTED,
  INCLUDE_SUPERSEDED,
  RAISED_THROUGH,
} from "src/util/enums/filters"
import { getWorkDomainWorkspaceListData } from "src/util/functions/entityData"
import { IssuesPageFilters, useFilterStore } from "src/stores/filterStore"
import { useTopNavigationStore } from "src/stores/topNavigationStore"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { onMounted, reactive, ref } from "vue"
import { useDialogPluginComponent } from "quasar"
import { useI18n } from "vue-i18n"

//region Props and Emits
//endregion

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogFilterTecModeIssues',
  setup(__props) {

const { t } = useI18n()
const filterStore = useFilterStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const workDomainOptions = ref<WorkDomainWorkspace[]>([])

let issuePageFilters = reactive<IssuesPageFilters>({ ...filterStore.issuesPageFilters })

//endregion

//region Lifecycle

onMounted(async () => {
  const workDomains = await getWorkDomainWorkspaceListData()
  workDomainOptions.value = workDomains.map((workDomain) => workDomain.toMutableJSON())
})

//endregion

//region Functions

function handleSystemLinkClose() {
  issuePageFilters.systemLink = undefined
  filterStore.issuesPageFilters.systemLink = undefined
}

function saveFilters() {
  filterStore.issuesPageFilters = issuePageFilters

  // Set the flag value
  filterStore.issuesPageFilters.hasFilters = true

  onDialogOK()

  router.replace({
    name: NamedManagerPath.SELECT_ISSUE,
    query: {
      filters: JSON.stringify(filterStore.issuesPageFilters),
    },
  })
}

function resetFilters() {
  filterStore.issuesPageFilters = structuredClone(ISSUE_FILTER_DIALOG_DEFAULT)
  issuePageFilters = structuredClone(ISSUE_FILTER_DIALOG_DEFAULT)

  // Remove the blue color badge from the filter icon
  const topNavigationStore = useTopNavigationStore()
  topNavigationStore.showFilterIconBadge = false

  onDialogCancel()
}

function selectAll() {
  issuePageFilters.state = ISSUE_FILTER_STATE
}

function selectNone() {
  issuePageFilters.state = []
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.title_filter_issues")), 1)
            ]),
            _: 1
          }),
          (_unref(issuePageFilters).systemLink)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(SfxFilterSystemLink, {
                    "system-link": _unref(issuePageFilters).systemLink,
                    onRemove: _cache[0] || (_cache[0] = ($event: any) => (handleSystemLinkClose()))
                  }, null, 8, ["system-link"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(SfxSelect, {
                class: "q-pb-sm",
                label: _ctx.$t('sfxDialogFilter.work_domain'),
                modelValue: _unref(issuePageFilters).workDomain,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(issuePageFilters).workDomain) = $event)),
                options: workDomainOptions.value,
                "option-label": (opt) => opt.designation,
                "option-value": (opt) => opt.id,
                loading: workDomainOptions.value?.length === 0,
                "emit-value": "",
                "map-options": "",
                "use-chips": "",
                multiple: ""
              }, null, 8, ["label", "modelValue", "options", "option-label", "option-value", "loading"]),
              _createVNode(SfxToggleSettings, {
                class: "q-py-none",
                html: "",
                trinary: "",
                modelValue: _unref(issuePageFilters).entityType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(issuePageFilters).entityType) = $event)),
                description: _unref(t)('sfxDialogFilter.entity_type'),
                "true-value": _unref(ENTITY_TYPE).ITEM,
                "true-label": _unref(t)('sfxDialogFilter.item'),
                "false-value": _unref(ENTITY_TYPE).AREA,
                "false-label": _unref(t)('sfxDialogFilter.area'),
                "indeterminate-value": _unref(ENTITY_TYPE).EITHER,
                "indeterminate-label": _unref(t)('sfxDialogFilter.either'),
                disable: ""
              }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"]),
              _createVNode(SfxToggleSettings, {
                class: "q-py-none",
                html: "",
                trinary: "",
                modelValue: _unref(issuePageFilters).raisedThrough,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(issuePageFilters).raisedThrough) = $event)),
                description: _unref(t)('sfxDialogFilter.raised_through'),
                "true-value": _unref(RAISED_THROUGH).YES,
                "true-label": _unref(t)('sfxDialogFilter.yes'),
                "false-value": _unref(RAISED_THROUGH).NO,
                "false-label": _unref(t)('sfxDialogFilter.no'),
                "indeterminate-value": _unref(RAISED_THROUGH).EITHER,
                "indeterminate-label": _unref(t)('sfxDialogFilter.either')
              }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"]),
              _createVNode(SfxToggleSettings, {
                class: "q-py-none",
                html: "",
                modelValue: _unref(issuePageFilters).includeSuperseded,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(issuePageFilters).includeSuperseded) = $event)),
                description: _unref(t)('sfxDialogFilter.included_supersede'),
                "true-value": _unref(INCLUDE_SUPERSEDED).YES,
                "true-label": _unref(t)('sfxDialogFilter.yes'),
                "false-value": _unref(INCLUDE_SUPERSEDED).NO,
                "false-label": _unref(t)('sfxDialogFilter.no')
              }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label"]),
              _createVNode(SfxToggleSettings, {
                class: "q-py-none",
                html: "",
                modelValue: _unref(issuePageFilters).includeRejected,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(issuePageFilters).includeRejected) = $event)),
                description: _unref(t)('sfxDialogFilter.include_rejected'),
                "true-value": _unref(INCLUDE_REJECTED).YES,
                "true-label": _unref(t)('sfxDialogFilter.yes'),
                "false-value": _unref(INCLUDE_REJECTED).NO,
                "false-label": _unref(t)('sfxDialogFilter.no')
              }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label"]),
              _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.priorities")), 1)
                ]),
                _: 1
              }),
              _createVNode(SfxPriorityFilter, {
                modelValue: _unref(issuePageFilters).priority,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(issuePageFilters).priority) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.states")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SfxBtnLink, {
                  class: "q-pl-none",
                  label: _unref(t)('sfxButtons.btn_select_none'),
                  onClick: selectNone
                }, null, 8, ["label"]),
                _createVNode(SfxBtnLink, {
                  class: "q-pr-none",
                  label: _unref(t)('sfxButtons.btn_select_all'),
                  onClick: selectAll
                }, null, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.raised")), 1),
                  _createVNode(_component_q_space),
                  _createVNode(_component_q_checkbox, {
                    modelValue: _unref(issuePageFilters).state,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(issuePageFilters).state) = $event)),
                    val: "raised",
                    size: "48px",
                    color: "secondary",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.in_work_order")), 1),
                  _createVNode(_component_q_space),
                  _createVNode(_component_q_checkbox, {
                    modelValue: _unref(issuePageFilters).state,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(issuePageFilters).state) = $event)),
                    val: "in_work_order",
                    size: "48px",
                    color: "secondary",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.corrected")), 1),
                  _createVNode(_component_q_space),
                  _createVNode(_component_q_checkbox, {
                    modelValue: _unref(issuePageFilters).state,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(issuePageFilters).state) = $event)),
                    val: "corrected",
                    size: "48px",
                    color: "secondary",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.closed")), 1),
                  _createVNode(_component_q_space),
                  _createVNode(_component_q_checkbox, {
                    modelValue: _unref(issuePageFilters).state,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(issuePageFilters).state) = $event)),
                    val: "closed",
                    size: "48px",
                    color: "secondary",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.corrected_closed")), 1),
                  _createVNode(_component_q_space),
                  _createVNode(_component_q_checkbox, {
                    modelValue: _unref(issuePageFilters).state,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(issuePageFilters).state) = $event)),
                    val: "corrected_closed",
                    size: "48px",
                    color: "secondary",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col q-mr-sm",
                onClick: resetFilters,
                label: _unref(t)('sfxButtons.btn_reset')
              }, null, 8, ["label"]),
              _createVNode(SfxBtn, {
                class: "col",
                onClick: saveFilters,
                label: _unref(t)('sfxButtons.btn_apply')
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})